import React, { useState, useRef, useEffect } from "react";
import { KendoTreeTable } from "../../Kendo/kendo_treetable";
import {
  Button,
  CommonErrorMsg,
  InfoIcon,
  ValidateForm,
  confirmDelete,
  sessionUser,
} from "../../Util/common";
import {
  CorebaseURL,
  corefetch,
  corepost,
  ImageURL,
} from "../../Util/axios_core_helper";
import { generateGuid } from "../../Kendo/kendo_common";
import { KendoGrid } from "../../Kendo/kendo_grid";
import { KendoLoader } from "../../Kendo/kendo_loader";
import { toast } from "react-toastify";

export const EventTipsImage = () => {
  const [error, setError] = useState({
    LeftImage: false,
    RightImage: false,
    ValidFile: false,
    InValidFileSizeLeft: false,
    InValidFileSizeRight: false,
    EmptyList: false,
  });
  const [EventTipsCount, setEventTipsCount] = useState();
  const [parentData, setParentData] = useState([]);
  const [isAddIcon, setIsAddIcons] = useState(true);
  const [isButtonVisible, setIsButtonVisible] = useState(true);
  const [childRowCountMap, setChildRowCountMap] = useState({});
  const [title, setTitle] = useState("");
  const modalRef = useRef(null);
  const [EventTipsImageList, setEventTipsImageList] = useState([]);
  const [Loading, setLoading] = useState(false);
  const [EventTipsImage, SetEventTipsImage] = useState({
    EventTipsImageId: 0,
    DisplayedInID: 0,
    DisplayedInName: "",
    LeftImage: "",
    OldLeftImagePath: "",
    RightImage: "",
    OldRightImagePath: "",
  });
  const [UpdateEventTipsImage, SetUpdateEventTipsImage] = useState({
    EventTipsImageId: 0,
    DisplayedInID: 0,
    DisplayedInName: "",
    LeftImage: "",
    OldLeftImagePath: "",
    RightImage: "",
    OldRightImagePath: "",
  });

  const fetchParentData = async () => {
    try {
      const response = await corefetch(`Packages/GetDisplayesInList`);
      if (response && response.length > 0) {
        const sortedTips = response
          .sort((a, b) => a.sortOrder - b.sortOrder)
          .filter(
            (item) => item.eventName?.trim().toLowerCase() !== "corporate"
          )
          .map((item) => ({ ...item, id: item.displayedInID }));

        setParentData(sortedTips);

        console.log("Filtered tips list:", sortedTips);
      } else {
        setParentData([]);
        console.log("No event tips found");
      }
    } catch (error) {
      console.error("Error fetching event tips:", error);
      setParentData([]);
    }
  };

  useEffect(() => {
    fetchParentData();
  }, []);

  const Parentscolumns = [
    {
      field: "displayedInID",
      filterable: false,
      hidden: true,
    },
    {
      field: "eventName",
      title: "Displayed In",
    },
  ];
  const childColumn = [
    { field: "eventTipsImageId", hidden: true },
    {
      field: "displayedInID",
      hidden: true,
    },
    {
      field: "displayedInName",
      hidden: true,
    },
    {
      template: function (e) {
        if (e.leftImagePath) {
          return `<img src="${ImageURL}${e.leftImagePath}" width="40px" height="40px" />`;
        }
        return "";
      },

      title: "Left Image",
      width: 50,
    },
    {
      template: function (e) {
        if (e.rightImagePath) {
          return `<img src="${ImageURL}${e.rightImagePath}" width="40px" height="40px" />`;
        }
        return "";
      },

      title: "Right Image",
      width: 50,
    },
  ];

  const clearForm = () => {
    setLoading(false);
    $("#hide").click();
    SetEventTipsImage({
      EventTipsImageId: 0,
      DisplayedInID: 0,
      DisplayedInName: "",
      LeftImage: "",
      OldLeftImagePath: "",
      RightImage: "",
      OldRightImagePath: "",
      previewLeftUrl: "",
      previewRightUrl: "",
    });
    setError({});
    setEventTipsImageList([]);
    setIsAddIcons(true);
    setIsButtonVisible(true);
    const fileInputs = document.querySelectorAll('input[type="file"]');
    fileInputs.forEach((input) => {
      input.value = null;
    });
  };

  const onValidation = (name, val) => {
    setError((prvErr) => {
      return {
        ...prvErr,
        [name]:
          !val || (val && val.trim() == "") || (val && val.trim().length == 0),
      };
    });
  };

  const handleEventTipsImageEditClick = (e) => {
    setTitle(e.child.displayedInName);
    SetUpdateEventTipsImage({
      DisplayedInID: e.parent.displayedInID,
      EventTipsImageId: e.child.eventTipsImageId,
      DisplayedInName: e.child.displayedInName,
      LeftImage: e.child.leftImagePath,
      OldLeftImagePath: e.child.leftImagePath,
      RightImage: e.child.rightImagePath,
      OldRightImagePath: e.child.rightImagePath,
    });
    setIsAddIcons(false);
    $("#update_EventTips").modal("show");
  };

  const handleDeleteClick = async (e) => {
    const onDelete = async () => {
      let SavedBy = sessionUser();
      await corefetch(
        `EventTips/DeleteEventTipsImage?eventTipsImageId=${e.eventTipsImageId}&deletedBy=${SavedBy}`,
        true,
        false,
        true
      );
      refreshChildGrd();
    };
    confirmDelete(onDelete);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const maxSizeInKB = 500;
    const maxSizeInBytes = maxSizeInKB * 1024;

    const leftImageError = !EventTipsImage.LeftImage;
    const rightImageError = !EventTipsImage.RightImage;
    const leftImageOversize = EventTipsImage.LeftImage?.size > maxSizeInBytes;
    const rightImageOversize = EventTipsImage.RightImage?.size > maxSizeInBytes;

    var err = ValidateForm(e);
    if (err) {
      setError({
        ...err,
        LeftImage: leftImageError,
        RightImage: rightImageError,
        InValidFileSizeLeft: leftImageOversize,
        InValidFileSizeRight: rightImageOversize,
      });
      return;
    }

    if (
      leftImageError ||
      rightImageError ||
      leftImageOversize ||
      rightImageOversize
    ) {
      setError({
        LeftImage: leftImageError,
        RightImage: rightImageError,
        InValidFileSizeLeft: leftImageOversize,
        InValidFileSizeRight: rightImageOversize,
      });
      return;
    }

    setError({
      LeftImage: false,
      RightImage: false,
      InValidFileSizeLeft: false,
      InValidFileSizeRight: false,
      EmptyList: false,
    });

    let temp = [{ ...EventTipsImage, guid: generateGuid() }];
    setEventTipsImageList([...EventTipsImageList, temp]);

    SetEventTipsImage((prev) => ({
      ...prev,
      LeftImage: "",
      RightImage: "",
      previewLeftUrl: "",
      previewRightUrl: "",
    }));

    const fileInputs = document.querySelectorAll('input[type="file"]');
    fileInputs.forEach((input) => {
      input.value = null;
    });

    if (temp.length == 0) {
      setError({ EmptyList: true });
    } else {
      try {
        setLoading(true);
        const formData = new FormData();

        temp.forEach((eventTipsImage, index) => {
          formData.append(
            `eventTipsModel[${index}].EventTipsImageId`,
            eventTipsImage.EventTipsImageId
          );
          formData.append(
            `eventTipsModel[${index}].DisplayedInID`,
            eventTipsImage.DisplayedInID || ""
          );
          formData.append(
            `eventTipsModel[${index}].OldLeftImagePath`,
            eventTipsImage.OldLeftImagePath
          );

          if (eventTipsImage.LeftImage) {
            formData.append(
              `eventTipsModel[${index}].LeftImage`,
              eventTipsImage.LeftImage
            );
          }
          formData.append(
            `eventTipsModel[${index}].OldRightImagePath`,
            eventTipsImage.OldRightImagePath
          );
          if (eventTipsImage.RightImage) {
            formData.append(
              `eventTipsModel[${index}].RightImage`,
              eventTipsImage.RightImage
            );
          }
        });

        await corepost("EventTips/InsertUpdateEventTipsImage", formData);

        $("#add_EventTips").modal("hide");
        clearForm();
        refreshChildGrd();
      } catch (error) {
        console.error(error);
        setLoading(false);
      }
    }
  };

  const onEditClick = async (e) => {
    try {
      let data = await corefetch(
        `EventTips/GetEventTipsCount?displayedInId=${e.displayedInID}`
      );

      if (data && data.eventTipsCount !== undefined) {
        const eventTipsCount = data.eventTipsCount;
        setEventTipsCount(eventTipsCount);

        if (eventTipsCount >= 1) {
          toast.error("Event Tips has been exceeded.");
        } else {
          const eventName = e.eventName;
          setTitle(eventName);

          SetEventTipsImage((prevBlog) => ({
            ...prevBlog,
            DisplayedInID: e.displayedInID,
          }));
          $("#add_EventTips").modal("show");
        }
      } else {
        console.error(
          "Failed to fetch banner count or received an invalid response."
        );
      }
    } catch (error) {
      console.error("Error fetching banner count:", error);
    }
  };

  const refreshChildGrd = () => {
    $(`#reload-EventTipsTT`)
      .next()
      .find(".k-master-row")
      .each(function (index) {
        if ($(this).find("td:first").find("a:first").hasClass("k-i-collapse")) {
          $(this).next().find(".btn-refresh:first").click();
        }
      });
  };

  const onUpdate = async (e) => {
    e.preventDefault();
    const maxSizeInKB = 500;
    const maxSizeInBytes = maxSizeInKB * 1024;

    const leftImageError =
      !UpdateEventTipsImage.LeftImage && !UpdateEventTips.OldLeftImagePath;
    const rightImageError =
      !UpdateEventTipsImage.RightImage && !UpdateEventTips.OldRightImagePath;

    const leftImageOversize =
      UpdateEventTipsImage.LeftImage?.size > maxSizeInBytes;
    const rightImageOversize =
      UpdateEventTipsImage.RightImage?.size > maxSizeInBytes;

    const formErrors = ValidateForm(e) || {};

    const errors = {
      ...formErrors,
      LeftImage: leftImageError,
      RightImage: rightImageError,
      InValidFileSizeLeft: leftImageOversize,
      InValidFileSizeRight: rightImageOversize,
    };

    const hasErrors = Object.values(errors).some((error) => error);

    if (hasErrors) {
      return;
    }

    try {
      setLoading(true);

      const formData = new FormData();
      formData.append(
        "eventTipsModel[0].EventTipsImageId",
        UpdateEventTipsImage.EventTipsImageId
      );
      formData.append(
        "eventTipsModel[0].DisplayedInID",
        UpdateEventTipsImage.DisplayedInID
      );

      if (UpdateEventTipsImage.LeftImage) {
        formData.append(
          "eventTipsModel[0].LeftImage",
          UpdateEventTipsImage.LeftImage
        );
      }
      formData.append(
        "eventTipsModel[0].OldLeftImagePath",
        UpdateEventTipsImage.OldLeftImagePath || ""
      );

      if (UpdateEventTipsImage.RightImage) {
        formData.append(
          "eventTipsModel[0].RightImage",
          UpdateEventTipsImage.RightImage
        );
      }
      formData.append(
        "eventTipsModel[0].OldRightImagePath",
        UpdateEventTipsImage.OldRightImagePath || ""
      );

      await corepost("EventTips/InsertUpdateEventTipsImage", formData);

      $("#update_EventTips").modal("hide");
      clearForm();
      refreshChildGrd();
    } catch (error) {
      console.error(error);
      toast.error("Failed to update event tips. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = (e, side) => {
    const file = e.target.files[0];

    const isUnsupportedFormat =
      file && !(file.type === "image/png" || file.type === "image/jpeg");

    if (isUnsupportedFormat) {
      toast.error("Unsupported image format uploaded.");
      e.target.value = null;
      return;
    }

    if (!file) {
      setError((prevError) => ({
        ...prevError,
        [side == "Left"
          ? "InValidFileSizeLeft"
          : "InValidFileSizeRight"]: false,
        ValidFile: false,
      }));

      SetEventTipsImage((prev) => ({
        ...prev,
        [`${side}Image`]: "",
      }));
      onValidation(`${side}Image`, "");
      return;
    }

    if (file.type.startsWith("image/")) {
      const maxSizeInKB = 500;
      const maxSizeInBytes = maxSizeInKB * 1024;
      const isFileTooLarge = file.size > maxSizeInBytes;

      setError((prevError) => ({
        ...prevError,
        ValidFile: false,
        [side == "Left" ? "InValidFileSizeLeft" : "InValidFileSizeRight"]:
          isFileTooLarge,
      }));

      if (isFileTooLarge) {
        SetEventTipsImage((prev) => ({
          ...prev,
          [`${side}Image`]: file,
        }));
      } else {
        const reader = new FileReader();
        reader.onloadend = () => {
          SetEventTipsImage((prev) => ({
            ...prev,
            [`${side}Image`]: file,
            [`preview${side.charAt(0).toUpperCase() + side.slice(1)}Url`]:
              reader.result,
          }));
        };
        reader.readAsDataURL(file);
      }

      onValidation(`${side}Image`, e.target.value);
    } else {
      e.target.value = "";
      setError((prevError) => ({
        ...prevError,
        ValidFile: true,
        [side == "Left"
          ? "InValidFileSizeLeft"
          : "InValidFileSizeRight"]: false,
      }));
      SetEventTipsImage((prev) => ({
        ...prev,
        [`${side}Image`]: "",
      }));
    }
  };

  const handleUpdateFileChange = (e, side) => {
    const file = e.target.files[0];

    const isUnsupportedFormat =
      file && !(file.type === "image/png" || file.type === "image/jpeg");

    if (isUnsupportedFormat) {
      toast.error("Unsupported image format uploaded.");
      e.target.value = null;
      return;
    }

    if (!file) {
      setError((prevError) => ({
        ...prevError,
        [side == "Left"
          ? "InValidFileSizeLeft"
          : "InValidFileSizeRight"]: false,
        ValidFile: false,
        [`${side}Image`]: false,
      }));
      SetUpdateEventTipsImage((prev) => ({
        ...prev,
        [`${side}Image`]: "",
      }));
      return;
    }

    if (file.type.startsWith("image/")) {
      const maxSizeInKB = 500;
      const maxSizeInBytes = maxSizeInKB * 1024;
      const isFileTooLarge = file.size > maxSizeInBytes;

      setError((prevError) => ({
        ...prevError,
        ValidFile: false,
        [side == "Left" ? "InValidFileSizeLeft" : "InValidFileSizeRight"]:
          isFileTooLarge,
        [`${side}Image`]: false,
      }));

      if (isFileTooLarge) {
        SetUpdateEventTipsImage((prev) => ({
          ...prev,
          [`${side}Image`]: file,
        }));
      } else {
        const reader = new FileReader();
        reader.onloadend = () => {
          SetUpdateEventTipsImage((prev) => ({
            ...prev,
            [`${side}Image`]: file,
            [`preview${side.charAt(0).toUpperCase() + side.slice(1)}Url`]:
              reader.result,
          }));
        };
        reader.readAsDataURL(file);
      }
    } else {
      e.target.value = "";
      setError((prevError) => ({
        ...prevError,
        ValidFile: true,
        [side == "Left"
          ? "InValidFileSizeLeft"
          : "InValidFileSizeRight"]: false,
      }));
      SetUpdateEventTipsImage((prev) => ({
        ...prev,
        [`${side}Image`]: "",
      }));
    }
  };

  return (
    <div className="container-fluid">
      <div className="col-auto ms-auto">
        {parentData && parentData.length > 0 && (
          <KendoTreeTable
            name={"EventTipsTT"}
            parentTableColumns={Parentscolumns}
            parentTableData={parentData}
            childTableUrl={
              CorebaseURL +
              "EventTips/GetEventTipsImageDetailsById?displayedinID={displayedInID}"
            }
            childTableColumns={childColumn}
            onParentEditClick={(row) => {
              if (childRowCountMap[row.id] !== 1) {
                onEditClick(row);
              }
            }}
            showParentOptions={true}
            showParentDelete={false}
            showChildOptions={true}
            showChildDelete={true}
            onChildEditClick={handleEventTipsImageEditClick}
            onChildDeleteClick={handleDeleteClick}
            refreshWhen={EventTipsImageList.length}
          />
        )}
        <div
          className="modal custom-modal fade"
          id="add_EventTips"
          role="dialog"
          ref={modalRef}
          aria-hidden="true"
          data-bs-backdrop="static"
        >
          <div
            className="modal-dialog modal-dialog-centered eventTips"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header d-flex justify-content-between align-items-center">
                <h5 className="modal-title">{title} - Add</h5>

                <button
                  type="button"
                  className="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={clearForm}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div className="modal-body">
                <form id="event-form" onSubmit={onSubmit}>
                  <input
                    type="hidden"
                    name="eventTipsImageId"
                    value={EventTipsImage.EventTipsImageId || 0}
                  />
                  <input
                    type="hidden"
                    name="displayedInID"
                    value={EventTipsImage.DisplayedInID || 0}
                  />
                  <div className="row">
                    <div className="col-10">
                      <label className="form-label">
                        Left Image <span className="text-danger">*</span>
                        <InfoIcon
                          content="Kindly Upload a Potrait Images for Optimal Display.;
                          Kindly upload an Image within 500KB size;
                                        Please upload the image in JPEG, JPG or PNG format."
                        />
                      </label>
                      <input
                        className="form-control"
                        type="file"
                        name="file"
                        accept="image/*"
                        onChange={(e) => handleFileChange(e, "Left")}
                      />
                      {error.LeftImage && (
                        <CommonErrorMsg
                          text="Left Image is required"
                          IsError={true}
                        />
                      )}
                      {error.ValidFile && (
                        <CommonErrorMsg
                          text="please upload Image file only"
                          IsError={true}
                        />
                      )}
                      {error.InValidFileSizeLeft && (
                        <CommonErrorMsg
                          text="File size exceeds 500KB. Please upload a smaller file."
                          IsError={true}
                        />
                      )}

                      <div className="mt-2">
                        {EventTipsImage.OldLeftImagePath &&
                          EventTipsImage.EventTipsImageId > 0 && (
                            <div
                              style={{
                                width: "100%",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              <a
                                href={`${ImageURL}${EventTipsImage.OldLeftImagePath}`}
                                target="_blank"
                                style={{
                                  textDecoration: "underline",
                                  fontSize: "13px",
                                }}
                              >
                                {EventTipsImage.OldLeftImagePath.split(
                                  "/"
                                ).pop()}
                              </a>
                            </div>
                          )}
                        <input
                          type="hidden"
                          name="Image"
                          id="image-name"
                          data-required="true"
                          value={EventTipsImage.LeftImage || ""}
                        />
                        <input
                          type="hidden"
                          name="OldimagePath"
                          value={EventTipsImage.OldLeftImagePath}
                        />
                      </div>
                    </div>
                    <div className="col-10 ">
                      <label className="form-label">
                        Right Image <span className="text-danger">*</span>
                        <InfoIcon
                          content="Kindly Upload a Potrait Images for Optimal Display.;
                          Kindly upload an Image within 500KB size;
                                        Please upload the image in JPEG, JPG or PNG format."
                        />
                      </label>
                      <input
                        className="form-control"
                        type="file"
                        name="file"
                        accept="image/*"
                        onChange={(e) => handleFileChange(e, "Right")}
                      />
                      {error.RightImage && (
                        <CommonErrorMsg
                          text="Right Image is required"
                          IsError={true}
                        />
                      )}
                      {error.ValidFile && (
                        <CommonErrorMsg
                          text="please upload Image file only"
                          IsError={true}
                        />
                      )}
                      {error.EmptyList && (
                        <CommonErrorMsg
                          text={"Please add at least one Event Tip Image"}
                          IsError={true}
                        />
                      )}
                      {error.InValidFileSizeRight && (
                        <CommonErrorMsg
                          text="File size exceeds 500KB. Please upload a smaller file."
                          IsError={true}
                        />
                      )}

                      <div className="mt-2">
                        {EventTipsImage.OldRightImagePath &&
                          EventTipsImage.EventTipsImageId > 0 && (
                            <div
                              style={{
                                width: "100%",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              <a
                                href={`${ImageURL}${EventTipsImage.OldRightImagePath}`}
                                target="_blank"
                                style={{
                                  textDecoration: "underline",
                                  fontSize: "13px",
                                }}
                              >
                                {EventTipsImage.OldRightImagePath.split(
                                  "/"
                                ).pop()}
                              </a>
                            </div>
                          )}
                        <input
                          type="hidden"
                          name="Image"
                          id="image-name"
                          data-required="true"
                          value={EventTipsImage.RightImage || ""}
                        />
                        <input
                          type="hidden"
                          name="OldimagePath"
                          value={EventTipsImage.OldRightImagePath}
                        />
                      </div>
                    </div>
                    {Loading ? (
                      <KendoLoader className="d-flex justify-content-end align-items-center" />
                    ) : (
                      <div className="text-end">
                        <Button
                          name={"Cancel"}
                          isCancelButton={true}
                          id="eventTips-cancel"
                          dataBsDismiss={"modal"}
                          onClick={() => {
                            clearForm();
                          }}
                        />
                        <Button name={"Save"} />
                      </div>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* update */}

        <div
          className="modal custom-modal fade"
          id="update_EventTips"
          role="dialog"
          ref={modalRef}
          aria-hidden="true"
          data-bs-backdrop="static"
        >
          <div
            className="modal-dialog modal-dialog-centered eventTips"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header d-flex justify-content-between align-items-center">
                <h5 className="modal-title">{title}-Edit</h5>

                <button
                  type="button"
                  className="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={clearForm}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div className="modal-body">
                <form id="update-form" onSubmit={onUpdate}>
                  <input
                    type="hidden"
                    name="eventTipsID"
                    value={UpdateEventTipsImage.EventTipsImageId || 0}
                  />
                  <input
                    type="hidden"
                    name="displayedInID"
                    value={UpdateEventTipsImage.DisplayedInID || 0}
                  />
                  <div className="row align-items-end">
                    <div className="row">
                      <div className="col-12">
                        <label className="form-label">
                          Left Image <span className="text-danger">*</span>
                          <InfoIcon
                            content="Kindly Upload a Potrait Images for Optimal Display.;
                             upload an Image within 500KB size;
                                           Please upload the image in JPEG, JPG or PNG format."
                          />
                        </label>
                        <input
                          className="form-control"
                          type="file"
                          name="file"
                          accept="image/*"
                          onChange={(e) => handleUpdateFileChange(e, "Left")}
                        />
                        {error.LeftImage && (
                          <CommonErrorMsg
                            text="Left Image is required"
                            IsError={true}
                          />
                        )}
                        {error.ValidFile && (
                          <CommonErrorMsg
                            text="please upload Image file only"
                            IsError={true}
                          />
                        )}
                        {error.InValidFileSizeLeft && (
                          <CommonErrorMsg
                            text="File size exceeds 500KB. Please upload a smaller file."
                            IsError={true}
                          />
                        )}
                      </div>
                      <div className="row mt-1 mb-3">
                        {UpdateEventTipsImage.OldLeftImagePath &&
                          UpdateEventTipsImage.EventTipsImageId > 0 && (
                            <div
                              style={{
                                width: "100%",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              <a
                                href={`${ImageURL}${UpdateEventTipsImage.OldLeftImagePath}`}
                                target="_blank"
                                style={{
                                  textDecoration: "underline",
                                  fontSize: "13px",
                                }}
                              >
                                {UpdateEventTipsImage.OldLeftImagePath.split(
                                  "/"
                                ).pop()}
                              </a>
                            </div>
                          )}
                        <input
                          type="hidden"
                          name="LeftImage"
                          id="image-name"
                          data-required="true"
                          value={UpdateEventTipsImage.LeftImage || ""}
                        />
                        <input
                          type="hidden"
                          name="OldLeftImagePath"
                          value={UpdateEventTipsImage.OldLeftImagePath}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <label className="form-label">
                          Right Image <span className="text-danger">*</span>
                          <InfoIcon
                            content="Kindly Upload a Potrait Images for Optimal Display.;
                            Kindly upload an Image within 500KB size;
                                           Please upload the image in JPEG, JPG or PNG format."
                          />
                        </label>
                        <input
                          className="form-control"
                          type="file"
                          name="file"
                          accept="image/*"
                          onChange={(e) => handleUpdateFileChange(e, "Right")}
                        />
                        {error.RightImage && (
                          <CommonErrorMsg
                            text="Right Image is required"
                            IsError={true}
                          />
                        )}
                        {error.ValidFile && (
                          <CommonErrorMsg
                            text="please upload Image file only"
                            IsError={true}
                          />
                        )}
                        {error.EmptyList && (
                          <CommonErrorMsg
                            text={"Please add at least one Event Tip Image"}
                            IsError={true}
                          />
                        )}
                        {error.InValidFileSizeRight && (
                          <CommonErrorMsg
                            text="File size exceeds 500KB. Please upload a smaller file."
                            IsError={true}
                          />
                        )}
                      </div>
                      <div className="row mt-1 mb-3">
                        {UpdateEventTipsImage.OldRightImagePath &&
                          UpdateEventTipsImage.EventTipsImageId > 0 && (
                            <div
                              style={{
                                width: "100%",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              <a
                                href={`${ImageURL}${UpdateEventTipsImage.OldRightImagePath}`}
                                target="_blank"
                                style={{
                                  textDecoration: "underline",
                                  fontSize: "13px",
                                }}
                              >
                                {UpdateEventTipsImage.OldRightImagePath.split(
                                  "/"
                                ).pop()}
                              </a>
                            </div>
                          )}
                        <input
                          type="hidden"
                          name="RightImage"
                          id="image-name"
                          data-required="true"
                          value={UpdateEventTipsImage.RightImage || ""}
                        />
                        <input
                          type="hidden"
                          name="OldRightImagePath"
                          value={UpdateEventTipsImage.OldRightImagePath}
                        />
                      </div>
                    </div>

                    {Loading ? (
                      <KendoLoader className="d-flex justify-content-end align-items-center" />
                    ) : (
                      <div className="text-end">
                        <Button
                          name={"Cancel"}
                          isCancelButton={true}
                          id="eventTips-cancel"
                          dataBsDismiss={"modal"}
                          onClick={() => {
                            clearForm();
                          }}
                        />
                        <Button name={"Update"} />
                      </div>
                    )}
                    <button
                      type="button"
                      id="hide"
                      style={{ display: "none" }}
                      data-bs-dismiss={"modal"}
                      onClick={() => {
                        clearForm();
                      }}
                    ></button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
